// @ts-nocheck
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import ReactHtmlParser from 'react-html-parser';
import PartnersList from '../../components/PartnersList';
import LinkButton from '../../uikit/Links/LinkButton';
import FileLink from '../../uikit/FileLink';
import { DICTIONARIES } from '../../utils/constants';

import Illustration from '../../assets/img/partners/illustration.png';
import ICropper from '../../interfaces/ICropper';

import './PartnersPage.sass';

import type { PartnersPageQuery, PartnersPageQuery$key } from './__generated__/PartnersPageQuery.graphql';

interface Props {
  query: PartnersPageQuery$key;
  labels: {
    [keys: string]: string;
  };
}

interface ISection {
  title: string;
  _id: string;
  _umbDocumentParents: {
    items: IPartner[];
  };
}

interface IPartner {
  partnerSiteUrl: string;
  picture: ICropper;
  _name: string;
  _createDate: string;
  _id?: string;
}

function PartnersPage(props: Props) {
  const data: PartnersPageQuery = useFragment(
    graphql`
			fragment PartnersPageQuery on PublishedContentByTypeQuery {
				partners {
					items {
						bottomTitle
						bottomText
						file
						fileTitle
						fileSize
            fileLastUpdateDate
						bottomText2
						... on PartnersPublishedContent {
							_children (orderBy: _updateDate_DESC) {
                items {
                  ... on PartnerPublishedContent {
                    _id
                    _name
                    _createDate
                    partnerSiteUrl
                    picture
                    section {
                      ... on PartnerSectionPublishedContent {
                        _id
                        title
                      }
                    }
                  }
                }
              }
							sections {
								... on PartnerSectionPublishedContent {
									_id
									title
									_umbDocumentParents(orderBy: _createDate_DESC) {
										items {
											... on PartnerPublishedContent {
												_name
												_createDate
												partnerSiteUrl
												picture
											}
										}
									}
								}
							}
						}
					}
				}
			}
		`,
    props.query
  );

  const [nestedData] = data?.partners?.items || [];
  const {
    bottomText,
    bottomText2,
    bottomTitle,
    fileLastUpdateDate,
    file,
    fileSize,
    fileTitle,
    _children: children,
    sections
  } = nestedData || {};

  const nonEmptyPartnersSection = sections?.filter(section => {
    const { items } = section?._umbDocumentParents || {};
    if (!items || !Array.isArray(items)) {
      return false;
    }
    return items.some((partner: IPartner) => Object.keys(partner).length > 0);
  });

  const emptySectionPartnersArray = children?.items?.filter((i: any) => !i.section);
  const lastUpdateAttachFile = fileLastUpdateDate.split('T')[0];

  return (
    <div className="partners-page">
      <div className="partners-page__list">
         {nonEmptyPartnersSection?.length > 0 && (
           nonEmptyPartnersSection.map((section: ISection) => (
            <div key={section._id} className="partners-page__item">
              <PartnersList partnersList={section}/>
            </div>
          ))
         )}
         {emptySectionPartnersArray.map((extraSection: ISection) => (
          <div key={extraSection._id} className="partners-page__item">
            <PartnersList partnersList={extraSection} title='Non section' />
          </div>
         ))}
      </div>
      <div className="partners-page__involve partners-involve">
        <Container>
          <Row>
            <Col xs={12} md={8}>
              <h2 className="uikit-heading-lg partners-involve__heading">
                {bottomTitle}
              </h2>
              <div className="partners-involve__content uikit-typo-container">
                {ReactHtmlParser(bottomText)}
              </div>
              <div className="partners-involve__file">
                <FileLink
                  key={1}
                  fileUrl={file}
                  fileName={fileTitle}
                  size={fileSize}
                  updateDate={lastUpdateAttachFile}
                />
              </div>
              <div className="partners-involve__cta uikit-typo-container">
                <p className="uikit-text-regular">
                  {bottomText2}
                </p>
                <LinkButton
                  id="partner_btn"
                  hrefSource="/become-a-partner"
                  label={props.labels[DICTIONARIES.partnersButton]}
                  isOrange
                  isExternal={false}
                />
              </div>
            </Col>
            <Col xs={12} md={4} className="partners-involve__illustration">
              <img src={Illustration} alt="Yo!"/>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default PartnersPage;
